import script from './Tooltip.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.tag,{tag:"component",staticClass:"tooltip-wrapper"},[_vm._t("default"),_vm._v(" "),_c('span',{class:("tooltip tooltip--" + (_vm.props.position)),domProps:{"innerHTML":_vm._s(("" + (_vm.props.text)))}})],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-fd9c8048_0", { source: ".tooltip[data-v-fd9c8048]{display:none;position:absolute;top:100%;opacity:0;right:-8px;z-index:900;padding:6px;border-radius:4px;color:#fff;background-color:rgba(51,51,51,.9);font-size:12px;font-weight:400;font-style:normal;line-height:16px;min-width:96px;width:auto;transition:all .1s ease-in}.tooltip-wrapper[data-v-fd9c8048]{position:relative;line-height:1}.tooltip-wrapper:hover .tooltip[data-v-fd9c8048]{display:block;opacity:1}.tooltip--top[data-v-fd9c8048]{top:16px}.tooltip--bottom[data-v-fd9c8048]{bottom:16px;top:unset}.tooltip--bottom-left[data-v-fd9c8048]{left:-128px}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-fd9c8048";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = true;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
